import { PrivilegeChecker } from 'omni-common-ui';
import Privileges from 'domain/Privileges';
import TabSwitcher, { TabCodes } from 'domain/TabSwitcher';
import MidtermAndFinalExam, { mapStateToProps } from './component';

import { routes as progressTestDayView } from '../ProgressTest/ProgressTestDayView';
import { routes as progressTestCourseView } from '../ProgressTest/ProgressTestCourseView';
import { routes as progressTestRubricView } from '../ProgressTest/ProgressTestRubricView';
import ViewNav from 'components/ViewNav';
import ProgressTestSessionNav from 'components/ProgressTestSessionNav';

const isAccessable = (state, groupId) => {
  const hasPrivilege = PrivilegeChecker.hasPrivilege(state, Privileges.ProgressTest.View);
  const isTabEnabled = TabSwitcher.isTabEnabled(state, groupId, TabCodes.MidtermAndFinalExam);
  const progressTestsPlan = state.get('rootReducer').get('progressTestsPlan').get(groupId);
  if (! progressTestsPlan || ! progressTestsPlan.data) {
    return hasPrivilege && isTabEnabled;
  }

  const hasMidtermOrFinalExam = progressTestsPlan && progressTestsPlan.data &&
    progressTestsPlan.data.find((ptp) => ptp.isUnitQuiz === false);

  return hasPrivilege && isTabEnabled && hasMidtermOrFinalExam;
};

export default ({ getState }) => ({
  appBars: {
    sticky: {
      ptNav: {
        component: ProgressTestSessionNav,
        props: {
          isUnitQuiz: false,
        },
        order: 1,
      },
      'view-nav': {
        component: ViewNav,
        props: {
          showExpandable: true,
        },
        order: 3,
      },
    },
  },
  path: 'exam',
  component: MidtermAndFinalExam,
  canAccess: ({ params }) => isAccessable(getState(), params.groupId),
  tab: {
    label: 'M_F Exam',
    order: 6,
    isVisible: (params) => isAccessable(getState(), params.groupId),
  },
  breadcrumbLabels: (props) => {
    const { params: { groupId, progressTestIndex }, buildRoute } = props;
    const currentProps = mapStateToProps(getState(), props);
    if (! currentProps || ! currentProps.currentProgressTestPlan) return;
    return {
      label: currentProps.currentProgressTestPlan.name,
      href: buildRoute(`/group/${groupId}/exam/${progressTestIndex}/course`),
    };
  },
  childRoutes: [
    progressTestDayView,
    progressTestCourseView,
    progressTestRubricView,
  ],
});



// WEBPACK FOOTER //
// ./containers/Group/MidtermAndFinalExam/routes.js